import { useTranslation } from 'react-i18next';
import { AppLocale } from './config';
import { getAppLocale } from './formatting';

export const useAppLocale = (): AppLocale => {
  const { i18n } = useTranslation();
  return getAppLocale(i18n.language);
};

